import { render, staticRenderFns } from "./TargetContentDetailedBlock.vue?vue&type=template&id=a8a6a9ea&scoped=true&"
import script from "./TargetContentDetailedBlock.vue?vue&type=script&lang=js&"
export * from "./TargetContentDetailedBlock.vue?vue&type=script&lang=js&"
import style0 from "./TargetContentDetailedBlock.vue?vue&type=style&index=0&id=a8a6a9ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a6a9ea",
  null
  
)

export default component.exports